// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fD7K","colMin":"styles_colMin__1S0Fl"};